<template>
    <!-- Payment Promotions -->
    <Alphacredit :activePartnumber="activePartnumber" />
    <Affirm :activePartnumber="activePartnumber" />
    <Cofidis :activePartnumber="activePartnumber" />
</template>
<script>
    import Alphacredit from '@/components/PaymentPromotions/Alphacredit.vue';
    import Affirm from '@/components/PaymentPromotions/Affirm.vue';
    import Cofidis from '@/components/PaymentPromotions/Cofidis.vue';
    export default {
        name: 'PaymentPromotions',
        props: ['activePartnumber'],
        components: {
            Alphacredit,
            Affirm,
            Cofidis
        }
    }
</script>
